import Icon from '../Icon';
import IconNotification from "../../icons/IconNotification.tsx";

export function StatusIndicatorGood() {
    return <div className="selfcare-delivery-flow-status">
        <Icon component={IconNotification}/>
        <p>Yay, dit installationsforløb kører på skinner!</p>
    </div>;
}
